import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ProjectsMenu = memo(({ isOpen, projects, onProjectSelect, menuId }) => {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="w-0 h-0 absolute sm:mt-[78px] sm:mr-[300px]
                  sm:border-l-[10px] border-l-transparent
                  sm:border-b-[15px] border-b-primary-400
                  sm:border-r-[10px] border-r-transparent
                  mt-[40px] mr-[180px]
                  border-l-[5px] 
                  border-b-[10px] 
                  border-r-[5px]
                  animate-slide-down"
      />
      <ul
        id={menuId}
        className="list-none absolute rounded-lg bg-white/90 backdrop-blur-md shadow-xl 
                 mt-[135px] mr-[120px] sm:mt-[220px] sm:mr-[220px] 
                 justify-start px-4 py-4 flex flex-col w-[100px] sm:w-[200px] 
                 animate-fade-in border border-primary-200
                 transform hover:scale-[1.02] transition-all duration-300"
      >
        {projects.map((project, index) => (
          <li
            onClick={() => onProjectSelect(project.id)}
            key={index}
            className="hover:bg-primary-100 hover:text-primary-900 rounded-md 
                     hover:pl-4 text-[13px] sm:text-[16px] py-2.5
                     transition-all duration-200 text-secondary-700 
                     cursor-pointer hover:shadow-sm"
          >
            {project.title}
          </li>
        ))}
      </ul>
    </>
  );
});

ProjectsMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
  onProjectSelect: PropTypes.func.isRequired,
  menuId: PropTypes.string.isRequired,
};

export default ProjectsMenu; 